import { ChannelType } from 'src/api/generated';

export const getContactAddressChannelLabelKey = (channelType: ChannelType) => {
  switch (channelType) {
    case ChannelType.EMAIL:
      return 'communications.contactPanel.contact.addresses.email';
    case ChannelType.WHATSAPP:
      return 'communications.contactPanel.contact.addresses.whatsapp';
    case ChannelType.PHONE:
    default:
      return 'communications.contactPanel.contact.addresses.phone';
  }
};
